import Axios from './axios_wrapper'

export function getMessages(page, userId, params) {
  return Axios({
    url: `/users/${userId}/messages?${params.join('&')}`,
    method: 'GET',
    page
  })
}

export function getMessage(userId, messageId) {
  return Axios({
    url: `/users/${userId}/messages/${messageId}`,
    method: 'GET'
  })
}

export function getSentMessages(page, params) {
  return Axios({
    url: `/admin/messages?${params.join('&')}`,
    method: 'GET',
    page
  })
}

export function sendMessage(data) {
  return Axios({
    url: '/messages',
    method: 'POST',
    data
  })
}

export function deleteMessage(userId, id) {
  return Axios({
    url: `/users/${userId}/messages/${id}`,
    method: 'DELETE'
  })
}

export function archiveMessage(userId, id, data) {
  return Axios({
    url: `/users/${userId}/messages/${id}`,
    method: 'PATCH',
    data
  })
}

export function checkUnreadMessages() {
  return Axios({
    url: `/unread_messages`,
    method: 'GET'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/messages.js
// module id = null
// module chunks = 